// extracted by mini-css-extract-plugin
export var fullHeightState = "_f-7";
export var headerCell = "_f-1";
export var loadingStateCell = "_f-4";
export var rowWrapper = "_f-3";
export var standaloneTable = "_f-8";
export var standaloneTableWithBodyFill = "_f-9";
export var stateCell = "_f-5";
export var table = "_f-0";
export var tableBodyFiller = "_f-6";
export var white = "_f-2";